import { ChatMessageResponse } from '../services/chatbot.service';

/**
 * Tras un turno en streaming, la respuesta queda en pantalla con un id temporal
 * ('msg-…'), porque el evento content_done llega antes de que el backend la guarde.
 * Esta función toma los mensajes recargados del servidor y le pone a la última
 * respuesta (y a la pregunta que la originó) su id real. Sin id real, el Asistente
 * no puede registrar feedback.
 */
export function reconcileLastTurn(
  local: ChatMessageResponse[],
  server: ChatMessageResponse[],
  turnStartIso: string
): ChatMessageResponse[] {
  const lastIdx = local.length - 1;
  const last = local[lastIdx];
  if (!last || last.role !== 'assistant') return local;
  if (!last.id.startsWith('msg-') || last.id.startsWith('msg-partial-')) return local;

  const start = new Date(turnStartIso).getTime() - 5000;
  let serverIdx = -1;
  for (let i = server.length - 1; i >= 0; i--) {
    if (server[i].role === 'assistant' && new Date(server[i].created_at).getTime() >= start) { serverIdx = i; break; }
  }
  if (serverIdx < 0) return local;

  const out = [...local];
  out[lastIdx] = { ...last, id: server[serverIdx].id };

  const prev = out[lastIdx - 1];
  if (prev && prev.role === 'user' && prev.id.startsWith('temp-user-')) {
    for (let j = serverIdx - 1; j >= 0; j--) {
      if (server[j].role === 'user') { out[lastIdx - 1] = { ...prev, id: server[j].id }; break; }
    }
  }
  return out;
}
